export const MainOrderFreight = 0
export const MainOrderVehicle = 1
